import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1800,1745 L1800,185 C1800,152 1773,125 1740,125 L180,125 C147,125 120,152 120,185 L120,1745 C120,1778 147,1805 180,1805 L1740,1805 C1773,1805 1800,1778 1800,1745 Z M1740,5 C1839.24,5 1920,85.76 1920,185 L1920,1745 C1920,1844.24 1839.24,1925 1740,1925 L180,1925 C80.76,1925 0,1844.24 0,1745 L0,185 C0,85.76 80.76,5 180,5 L1740,5 Z M859.522039,853.668863 L699.522039,853.668863 L699.522039,800.335529 L486.188706,800.335529 L486.188706,1120.33553 L699.522039,1120.33553 L699.522039,1067.0022 L859.522039,1067.0022 L859.522039,1173.66886 C859.522039,1232.33553 811.522039,1280.33553 752.855373,1280.33553 L432.855373,1280.33553 C374.188706,1280.33553 326.188706,1232.33553 326.188706,1173.66886 L326.188706,747.002196 C326.188706,688.335529 374.188706,640.335529 432.855373,640.335529 L752.855373,640.335529 C811.522039,640.335529 859.522039,688.335529 859.522039,747.002196 L859.522039,853.668863 Z M1584.52204,853.668863 L1424.52204,853.668863 L1424.52204,800.335529 L1211.18871,800.335529 L1211.18871,1120.33553 L1424.52204,1120.33553 L1424.52204,1067.0022 L1584.52204,1067.0022 L1584.52204,1173.66886 C1584.52204,1232.33553 1536.52204,1280.33553 1477.85537,1280.33553 L1157.85537,1280.33553 C1099.18871,1280.33553 1051.18871,1232.33553 1051.18871,1173.66886 L1051.18871,747.002196 C1051.18871,688.335529 1099.18871,640.335529 1157.85537,640.335529 L1477.85537,640.335529 C1536.52204,640.335529 1584.52204,688.335529 1584.52204,747.002196 L1584.52204,853.668863 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconClosedCaptioningLine = /*#__PURE__*/function (_Component) {
  _inherits(IconClosedCaptioningLine, _Component);

  var _super = _createSuper(IconClosedCaptioningLine);

  function IconClosedCaptioningLine() {
    _classCallCheck(this, IconClosedCaptioningLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconClosedCaptioningLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconClosedCaptioning",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconClosedCaptioningLine.displayName = "IconClosedCaptioningLine";
  return IconClosedCaptioningLine;
}(Component);

IconClosedCaptioningLine.glyphName = 'closed-captioning';
IconClosedCaptioningLine.variant = 'Line';
IconClosedCaptioningLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconClosedCaptioningLine;
export { IconClosedCaptioningLine };